{
  "version": 1,
  "asset_id": "e0ad6a4c-6323-4d9b-8530-08388e5a934e",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/e0ad6a4c-6323-4d9b-8530-08388e5a934e/prima3.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/e0ad6a4c-6323-4d9b-8530-08388e5a934e/prima3.webp",
  "original_filename": "prima3.webp",
  "size": 86372,
  "content_type": "image/webp",
  "created_at": "2026-08-07T09:36:36Z"
}
